const router = [
  {
    path: '/production/tax/sign/:id/:signType',
    name: 'ProductionTaxSign',
    component: () => import('@/views/production-tax/ProductionTaxSign.vue'),
    meta: {
      title: '生产经营税收签名',
      checkToken: false
    }
  }
];
export default router;
